<template>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-monitor</v-icon>
      Desktop
    </div>
    <v-spacer />
  </div>
  <v-divider class="mt-3" />
  <div class="config-page-body">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <v-card-subtitle>Wallpaper</v-card-subtitle>
      <v-divider />
      <div
        class="mt-3"
        style="display: flex; align-items: center; gap: 12px">
        <v-switch
          v-model="wallpaperEnabled"
          label="Apply branded CanvasPro wallpaper"
          color="primary"
          density="compact"
          hide-details
          :loading="saving"
          @update:modelValue="toggleWallpaper" />
      </div>
      <div class="text-caption text-grey mt-2">
        <v-icon
          size="small"
          class="mr-1">
          mdi-information-outline
        </v-icon>
        Sets the desktop wallpaper to a branded image with the machine name
      </div>
      <div
        class="mt-3"
        style="display: flex; align-items: center; gap: 12px">
        <v-switch
          v-model="showIpEnabled"
          label="Show IP addresses and QR code"
          color="primary"
          density="compact"
          hide-details
          :disabled="!wallpaperEnabled"
          :loading="savingIp"
          @update:modelValue="toggleShowIp" />
      </div>
      <div class="text-caption text-grey mt-2">
        <v-icon
          size="small"
          class="mr-1">
          mdi-information-outline
        </v-icon>
        Displays machine IP addresses and a QR code linking to the web UI
      </div>
    </div>
  </div>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import { $http } from '../../stores/http.js';
import { ref, onMounted } from 'vue';

const wallpaperEnabled = ref(false);
const showIpEnabled = ref(false);
const saving = ref(false);
const savingIp = ref(false);

async function toggleWallpaper(enabled) {
  saving.value = true;
  try {
    await $http('PUT', `/set_desktop_wallpaper?enabled=${enabled}`);
  } catch (error) {
    console.log('Failed to toggle desktop wallpaper:', error);
    wallpaperEnabled.value = !enabled;
  } finally {
    saving.value = false;
  }
}

async function toggleShowIp(enabled) {
  savingIp.value = true;
  try {
    await $http('PUT', `/set_wallpaper_show_ip?enabled=${enabled}`);
  } catch (error) {
    console.log('Failed to toggle wallpaper show IP:', error);
    showIpEnabled.value = !enabled;
  } finally {
    savingIp.value = false;
  }
}

onMounted(async () => {
  wallpaperEnabled.value =
    deluge.config?.extra_info?.desktop_wallpaper_enabled ?? false;
  try {
    showIpEnabled.value = await $http('GET', '/get_wallpaper_show_ip');
  } catch {
    showIpEnabled.value = false;
  }
});
</script>
<style scoped>
@import './config.css';
</style>
